<div class="criteria-content">
  <mat-form-field>
    <mat-chip-grid #chipGrid>
      @for (elem of selectedElements; track elem; let i = $index) {
        <mat-chip-option removable="true" (removed)="removeElement(i)"
          >
          {{ elem}}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-option>
      }

      <input matInput #chipCategoryInput placeholder="{{placeholder}}"
        [formControl]="selectedElement"
        [matAutocomplete]="autoComplete"
        [matChipInputFor]="chipGrid"
        [matChipInputAddOnBlur]="false" />
      </mat-chip-grid>

      <mat-autocomplete #autoComplete="matAutocomplete" (optionSelected)="addElement($event)">
        @for (elem of filteredElements; track elem) {
          <mat-option [value]="elem" >
            {{ elem }}
          </mat-option>
        }
      </mat-autocomplete>

      @if (max !== -1) {
        <mat-hint>Maximum de {{ max }} éléments.</mat-hint>
      }
    </mat-form-field>
  </div>
